import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { useState, useLayoutEffect } from 'react';

var SCROLL_UP = "up";
var SCROLL_DOWN = "down";
var useScrollDirection = function useScrollDirection(_ref) {
  var _ref$initialDirection = _ref.initialDirection,
    initialDirection = _ref$initialDirection === void 0 ? SCROLL_UP : _ref$initialDirection,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 50 : _ref$threshold;
  var _useState = useState(initialDirection),
    _useState2 = _slicedToArray(_useState, 2),
    scrollDir = _useState2[0],
    setScrollDir = _useState2[1];
  useLayoutEffect(function () {
    var lastScrollY = window.pageYOffset;
    var ticking = false;
    var updateScrollDir = function updateScrollDir() {
      var scrollY = window.pageYOffset;
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP);
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };
    var onScroll = function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll);
    return function () {
      return window.removeEventListener("scroll", onScroll);
    };
  }, [initialDirection, threshold]);
  return scrollDir;
};

export { useScrollDirection };
